var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        id: "itemModal",
        title: _vm.actionDisplay,
        centered: "",
        scrollable: "",
      },
      on: { hidden: _vm.clear },
      model: {
        value: _vm.show,
        callback: function ($$v) {
          _vm.show = $$v
        },
        expression: "show",
      },
    },
    [
      _c("input", {
        staticStyle: { display: "none" },
        attrs: { id: "fileInput", type: "file" },
        on: { change: _vm.onFileChanged },
      }),
      _vm._v(" "),
      _c(
        "b-form",
        { staticClass: "enter-item-form" },
        [
          _c(
            "b-row",
            [
              _c("b-col", [
                _c(
                  "div",
                  { staticClass: "item-modal-picture-container" },
                  [
                    _c("picture-placeholder", {
                      attrs: {
                        textIn:
                          null != _vm.item.name
                            ? _vm.item.name.toLowerCase()
                            : "",
                        pictureUrl: _vm.itemImageUri,
                        color: "#fff",
                      },
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "hover-upload-button" }, [
                      _c(
                        "span",
                        {
                          staticClass: "upload-photo-label",
                          on: { click: _vm.startImageUpload },
                        },
                        [
                          _vm._v("\n              upload"),
                          _c("br"),
                          _vm._v("photo\n            "),
                        ]
                      ),
                    ]),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { sm: "8" } },
                [
                  _c(
                    "info-row",
                    {
                      staticClass: "info-main-row",
                      attrs: { sizing: 3, title: "Name" },
                    },
                    [
                      _c(
                        "b-col",
                        { staticClass: "input-group" },
                        [
                          _c("b-form-input", {
                            staticClass: "form-control",
                            attrs: {
                              "data-cy": "item-name",
                              type: "text",
                              title: "Item Name",
                              placeholder: "Cheeseburger",
                              required: "",
                              state: _vm.fieldState.itemName,
                            },
                            model: {
                              value: _vm.itemName,
                              callback: function ($$v) {
                                _vm.itemName = $$v
                              },
                              expression: "itemName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "info-row",
                    {
                      staticClass: "info-main-row",
                      attrs: { sizing: 3, title: "Description" },
                    },
                    [
                      _c(
                        "b-col",
                        { staticClass: "input-group" },
                        [
                          _c("b-form-input", {
                            staticClass: "form-control",
                            attrs: {
                              "data-cy": "item-description",
                              type: "text",
                              required: "",
                              title: "Description",
                              placeholder: "Typical quarter pounder",
                              state: _vm.fieldState.description,
                              value: _vm.description,
                            },
                            model: {
                              value: _vm.description,
                              callback: function ($$v) {
                                _vm.description = $$v
                              },
                              expression: "description",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "info-row",
                    {
                      staticClass: "info-main-row",
                      attrs: { sizing: 3, title: "Rate" },
                    },
                    [
                      _vm.show
                        ? _c("currency-input", {
                            ref: "rateInput",
                            attrs: {
                              "data-cy": "item-rate",
                              name: "Default Rate",
                              amount: _vm.defaultRate,
                              fieldState: _vm.fieldState.defaultRate,
                            },
                            on: {
                              "update:amount": function ($event) {
                                _vm.defaultRate = $event
                              },
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c("b-col", { attrs: { sm: "2" } }),
              _vm._v(" "),
              _c("b-col", { attrs: { sm: "10" } }),
            ],
            1
          ),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c("Taggregator", {
            ref: "tagsTaggregator",
            attrs: {
              labelKey: "name",
              label: "Item Tags",
              items: _vm.getTags,
              selections: _vm.selectedTags,
              minimum: 0,
              name: "tags",
              quickAddCallback: _vm.quickAddTag,
              quickAddMinWordCount: 1,
              quickAddMinWordLength: 1,
              quickAddDescription: "Please provide valid item name",
              quickAddHasUniqueName: true,
            },
            on: {
              "update:selections": function ($event) {
                _vm.selectedTags = $event
              },
            },
            scopedSlots: _vm._u([
              {
                key: "result",
                fn: function ({ result }) {
                  return [
                    _c("span", { staticClass: "result-label" }, [
                      _vm._v(
                        "\n          " + _vm._s(result.name) + "\n        "
                      ),
                    ]),
                  ]
                },
              },
              {
                key: "selection",
                fn: function ({ selection }) {
                  return [
                    _vm._v("\n        " + _vm._s(selection.name) + "\n      "),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "w-100",
          attrs: { slot: "modal-footer" },
          slot: "modal-footer",
        },
        [
          _c("span", { staticClass: "text-danger" }, [
            _vm._v(_vm._s(_vm.warningText)),
          ]),
          _vm._v(" "),
          _vm.item.id
            ? _c(
                "b-btn",
                {
                  staticClass: "float-left",
                  attrs: { variant: "danger" },
                  on: { click: _vm.deleteItem },
                },
                [_vm._v("\n      Delete Item\n    ")]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "b-btn",
            {
              staticClass: "float-right",
              attrs: { variant: "success", "data-cy": "add-item" },
              on: { click: _vm.triggerItem },
            },
            [_vm._v("\n      " + _vm._s(_vm.actionDisplay) + "\n    ")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.isRequesting
        ? _c(
            "div",
            { staticClass: "item-modal-spinner" },
            [_c("spinner-loader")],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("image-upload-modal", { ref: "upload-modal" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }